/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_People_QInputs */

const en_mk_tb_faq_people_q = /** @type {(inputs: Mk_Tb_Faq_People_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can each developer use a different AI tool?`)
};

const id_mk_tb_faq_people_q = /** @type {(inputs: Mk_Tb_Faq_People_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah setiap developer bisa memakai AI yang berbeda?`)
};

/**
* | output |
* | --- |
* | "Can each developer use a different AI tool?" |
*
* @param {Mk_Tb_Faq_People_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_people_q = /** @type {((inputs?: Mk_Tb_Faq_People_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_People_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_people_q(inputs)
	return en_mk_tb_faq_people_q(inputs)
});